import React, { useMemo } from 'react';
import { IconButton } from '../../../controls/Controls.jsx';
import {
  CalendarOutlined,
  DeleteOutlined,
  EditOutlined,
  FileSearchOutlined,
  UserAddOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import useUserHasRole from '../../../../../hooks/useUserHasRoles.jsx';
import { ROLE_FRI_OPEN_ADMIN } from '../../../../../utils/constants/roles.js';

export function WorkshopsListTableSettings({
  workshop,
  onShowDatesClick,
  onEditClick,
  onDelete,
  onDetailClick,
  onSignOnClick,
  isArchivedEvent,
}) {
  const { t } = useTranslation();
  const user = useSelector((s) => s.auth?.user);

  const isAdmin = useUserHasRole(ROLE_FRI_OPEN_ADMIN);

  const isAuthorOfWorkshop = useMemo(() => {
    return user?.id && workshop?.creator_id
      ? Number(user.id) === Number(workshop.creator_id)
      : false;
  }, [user?.id, workshop?.creator_id]);

  const isLecturerOfWorkshop = useMemo(() => {
    return user?.id && workshop?.lecturer_id
      ? Number(user.id) === Number(workshop.lecturer_id)
      : false;
  }, [user?.id, workshop?.lecturer_id]);

  return (
    <div style={{ display: 'flex' }}>
      {onEditClick &&
      !isArchivedEvent &&
      (isAuthorOfWorkshop || isLecturerOfWorkshop || isAdmin) ? (
        <IconButton
          icon={<EditOutlined />}
          tooltip={t('Upraviť')}
          onClick={(e) => {
            e.stopPropagation();
            onEditClick(workshop);
          }}
        />
      ) : null}
      {onDetailClick ? (
        <IconButton
          icon={<FileSearchOutlined />}
          tooltip={t('Zobraziť detail seminára')}
          onClick={(e) => {
            e.stopPropagation();
            onDetailClick(workshop);
          }}
        />
      ) : null}
      {onShowDatesClick ? (
        <IconButton
          icon={<CalendarOutlined />}
          tooltip={t('Zobraziť zoznam termínov')}
          onClick={(e) => {
            e.stopPropagation();
            onShowDatesClick(workshop);
          }}
        />
      ) : null}

      {onSignOnClick ? (
        <IconButton
          icon={<UserAddOutlined />}
          tooltip={t('Termíny seminára')}
          onClick={(e) => {
            e.stopPropagation();
            onSignOnClick(workshop);
          }}
        />
      ) : null}
      {onDelete &&
      !isArchivedEvent &&
      (isAuthorOfWorkshop || isLecturerOfWorkshop || isAdmin) ? (
        <IconButton
          icon={<DeleteOutlined />}
          tooltip={t('Vymazať')}
          onClick={(e) => {
            e.stopPropagation();
            onDelete(workshop);
          }}
        />
      ) : null}
    </div>
  );
}
